import HeaderNew from './HeaderNew';

export default HeaderNew;